import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";
import { EventAccessParams } from "../models/EventAccessParams";
import { VisibleEvent } from "./../models/VisibleEvent";

@Injectable({
  providedIn: "root",
})
export class VisibleEventService {
  private baseUrl = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/admin/visibleEvent`;

  constructor(private http: HttpClient) {}

  getParams() {
    return this.http.get<EventAccessParams>(this.baseUrl + "/params");
  }

  getVisibleEvents(famCode: string, roleName: string) {
    return this.http.get<VisibleEvent[]>(
      this.baseUrl + "?famCode=" + famCode + "&roleName=" + roleName,
    );
  }

  activateEvent(famCode: string, role: string, eventName: string) {
    return this.http.post(this.baseUrl, { famCode: famCode, role, eventName });
  }

  deactivateEvent(famCode: string, role: string, eventName: string) {
    return this.http.delete(
      this.baseUrl + "?famCode=" + famCode + "&role=" + role + "&eventName=" + eventName,
    );
  }
}
